export const SEVER_URL = "https://boiling-headland-45957.herokuapp.com";
// export const SEVER_URL = "http://127.0.0.1:4000";
export const DOMAIN = "https://the-god-project.com";
export const CRYPT_KEY = 'LovelyDev892_key_001'
export const CLIENT_ID = '535357053817-ukg4lr0m0dcpo8ef70dioelf5b4dasj4.apps.googleusercontent.com'
// export const CLIENT_ID = '707788443358-u05p46nssla3l8tmn58tpo9r5sommgks.apps.googleusercontent.com'  //works on localhost
// export const CLIENT_ID = '316927714071-82f8g7ba69432r076iu34aq9o142633r.apps.googleusercontent.com'
export const MAX_NUM = Number.MAX_SAFE_INTEGER